import { render, staticRenderFns } from "./PopupListMedicine.vue?vue&type=template&id=232775f0&scoped=true&"
import script from "./PopupListMedicine.vue?vue&type=script&lang=ts&"
export * from "./PopupListMedicine.vue?vue&type=script&lang=ts&"
import style0 from "./PopupListMedicine.vue?vue&type=style&index=0&id=232775f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232775f0",
  null
  
)

export default component.exports